// Central content file — easy to edit copy & assets in one place.

export const ASSETS = {
  appIcon:
    "https://customer-assets.emergentagent.com/job_purrse-preview/artifacts/s0evxlft_Purrse%20Icon.png",
  shots: {
    welcome:
      "https://customer-assets.emergentagent.com/job_purrse-preview/artifacts/go4fir8s_Purrse%20Screenshot%201.jpg",
    valueCoins:
      "https://customer-assets.emergentagent.com/job_purrse-preview/artifacts/9t5gac6j_Purrse%20Screenshot%202.jpg",
    addExpense:
      "https://customer-assets.emergentagent.com/job_purrse-preview/artifacts/e3eo631z_Purrse%20Screenshot%203.jpg",
    scanReceipt:
      "https://customer-assets.emergentagent.com/job_purrse-preview/artifacts/9f4vio8m_Purrse%20Screenshot%204.jpg",
  },
};

export const STEPS = [
  {
    title: "Pick three joy buckets.",
    body:
      "The things genuinely worth spending on. Coffee. Concert tickets. Bookstore hauls. Whatever yours are.",
  },
  {
    title: "Set your fun budget.",
    body:
      "A monthly amount that sits separate from rent, bills, and savings — so spending it is the plan, not the problem.",
  },
  {
    title: "Go live your life.",
    body:
      "Bast keeps watch with gentle nudges instead of tiny red warnings shouting at you on a Tuesday.",
  },
];

export const DIFFERENCES = [
  {
    title: "A money app that feels good to open",
    body: "No spreadsheets. No guilt. No confessions. Just a calm space for your spending.",
  },
  {
    title: "Built around joy, not punishment",
    body: "Spend tracking that celebrates what lights you up instead of scolding you for it.",
  },
  {
    title: "Gentle nudges, never alarms",
    body: "Bast taps you on the shoulder kindly — she never sets off the fire alarm.",
  },
  {
    title: "A mascot with excellent taste",
    body: "Bast has opinions, a little side eye, and your back. Light and dark mode, both cat-approved.",
  },
];

// ---- Privacy Policy (placeholder — edit freely) ----
export const PRIVACY = {
  updated: "Last updated: June 2026",
  intro:
    "This is placeholder text for the Purrse Privacy Policy. Replace each section below with your finalized legal copy. Bast promises to keep this readable.",
  sections: [
    {
      heading: "1. Information We Collect",
      body:
        "We collect your email address for authentication, which is handled via Emergent Auth. We also store the budget buckets you create and the expenses you log so the app can work for you.",
    },
    {
      heading: "2. How We Use Your Information",
      body:
        "Your information powers features like budget tracking, gentle nudges, and receipt scanning. We do not sell user data.",
    },
    {
      heading: "3. Financial Information",
      body:
        "Purrse does not collect or store any credit card numbers, bank account details, or other financial data. All payments (if any) are handled by third-party providers like Apple, and we never see or store your payment information.",
    },
    {
      heading: "4. AI Features & Data Security",
      body:
        "Some features use AI to help you (for example, reading a receipt total and suggesting a bucket). Data processed by our AI features is handled securely and is not used for model training.",
    },
    {
      heading: "5. Data Storage & Security",
      body:
        "Your data is stored in secure cloud environments, and we use encryption to protect information during transmission. We follow industry best practices to prevent unauthorized access to your data.",
    },
    {
      heading: "6. Your Rights & Choices",
      body:
        "You can request deletion of your account at any time by contacting us at carolineselia@gmail.com. You can also manage your notification preferences from within the app.",
    },
    {
      heading: "7. Contact Us",
      body:
        "Questions about your privacy or your data? Reach out any time at carolineselia@gmail.com, or use the Support form on this page.",
    },
  ],
};
